import styled from 'styled-components';
import { GoalsPageControlbar } from './components/GoalsPageControlbar';
import { GoalsPageHeader } from './components/GoalsPageHeader';
import { GoalsPageTable } from './components/GoalsPageTable';
import { GoalsProvider } from './contexts/GoalsContext';
import { ModalProvider } from './contexts/ModalContext';
import { Modals } from './modals';

const withGoalsPageContexts =
  <GoalsPageConsumerProps extends Record<string | number, unknown>>(
    GoalsPageConsumer: React.FC<GoalsPageConsumerProps>,
  ) =>
  (props: GoalsPageConsumerProps) => {
    return (
      <ModalProvider>
        <GoalsProvider>
          <GoalsPageConsumer {...props} />
          <Modals />
        </GoalsProvider>
      </ModalProvider>
    );
  };

const Container = styled.div`
  margin: 0;
  padding: 0;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const GOALS_PAGE_TEST_IDS = {
  GOALS_PAGE: 'goals-page',
};

export const GoalsPage = withGoalsPageContexts(() => {
  return (
    <Container data-testid={GOALS_PAGE_TEST_IDS.GOALS_PAGE}>
      <GoalsPageHeader />
      <GoalsPageControlbar />
      <GoalsPageTable />
    </Container>
  );
});
